import { render, staticRenderFns } from "./build-wizardtemplate.vue?vue&type=template&id=616d4070&"
import script from "./build-wizardtemplate.vue?vue&type=script&lang=js&"
export * from "./build-wizardtemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports